import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReorder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReorder"><Path d="M6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3Z" fill="currentColor"/><Path d="M16.9142 4.5L15.5 3.08579L12.0858 6.5L15.5 9.91421L16.9142 8.5L15.9142 7.5H19V16.5H13V18.5H21V5.5H15.9142L16.9142 4.5Z" fill="currentColor"/><Path d="M6.5 14C4.567 14 3 15.567 3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReorder;
